var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 20,
    viewBox: "0 0 115 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 15L4.12215 18.0902L5.24472 11.5451L0.489435 6.90983L7.06107 5.95492L10 0L12.9389 5.95492L19.5106 6.90983L14.7553 11.5451L15.8779 18.0902L10 15Z",
    fill: "#FCBF59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58 15L52.1221 18.0902L53.2447 11.5451L48.4894 6.90983L55.0611 5.95492L58 0L60.9389 5.95492L67.5106 6.90983L62.7553 11.5451L63.8779 18.0902L58 15Z",
    fill: "#FCBF59"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34 15L28.1221 18.0902L29.2447 11.5451L24.4894 6.90983L31.0611 5.95492L34 0L36.9389 5.95492L43.5106 6.90983L38.7553 11.5451L39.8779 18.0902L34 15Z",
    fill: "#FCBF59"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81 15L75.1221 18.0902L76.2447 11.5451L71.4894 6.90983L78.0611 5.95492L81 0L83.9389 5.95492L90.5106 6.90983L85.7553 11.5451L86.8779 18.0902L81 15Z",
    fill: "#FCBF59"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M105 15L99.1221 18.0902L100.245 11.5451L95.4894 6.90983L102.061 5.95492L105 0L107.939 5.95492L114.511 6.90983L109.755 11.5451L110.878 18.0902L105 15Z",
    fill: "#FCBF59"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.a1996c3ae04fcc953797050e6114d173.svg";
export { ForwardRef as ReactComponent };